"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Viewer = void 0;
const react_1 = __importStar(require("react"));
const use_open_seadragon_1 = require("use-open-seadragon");
const openseadragon_1 = require("openseadragon");
const styled_components_1 = __importDefault(require("styled-components"));
const use_media_1 = require("use-media");
const AppContext_1 = require("../../contexts/AppContext");
const ScreenSizes_1 = require("../../styles/ScreenSizes");
const ViewerWrapper = styled_components_1.default.div `
	width: 100vw;
	height: 100vh;
	cursor: ${(p) => p.cursor};
`;
const Viewer = ({ children, path }) => {
    const [viewerLoaded, setViewerLoaded] = react_1.useState(false);
    const isMobile = use_media_1.useMediaLayout(ScreenSizes_1.screenSize.sm);
    const { selectedMarker } = AppContext_1.useAppContext();
    const [viewerCursor, setViewerCursor] = react_1.useState('default');
    use_open_seadragon_1.useViewerEvent('canvas-drag', () => setViewerCursor('grabbing'));
    use_open_seadragon_1.useViewerEvent('canvas-drag-end', () => setViewerCursor('default'));
    use_open_seadragon_1.useViewerEvent('tile-loaded', () => setViewerLoaded(true));
    const [openSeadragonRef, { viewer }] = use_open_seadragon_1.useOpenSeadragon(path, {
        // debugMode: true,
        degrees: 0,
        showNavigationControl: false,
        constrainDuringPan: true,
        immediateRender: true,
        visibilityRatio: 0.1,
        maxImageCacheCount: 10000,
        // springStiffness: 6.5,
        // smoothTileEdgesMinZoom: 1,
        useCanvas: true,
        preload: true,
        animationTime: 1.2,
        defaultZoomLevel: 1,
        minZoomLevel: 1,
        maxZoomLevel: 15,
        minZoomImageRatio: 0.01,
        maxZoomPixelRatio: 1,
        gestureSettingsMouse: {
            scrollToZoom: true,
            clickToZoom: false,
            dblClickToZoom: true,
            pinchToZoom: false,
            flickEnabled: false,
            flickMinSpeed: 120,
            flickMomentum: 0.25,
        },
        // gestureSettingsTouch: {
        // 	dblClickToZoom: false,
        // 	pinchToZoom: true,
        // 	flickEnabled: false,
        // },
        panHorizontal: true,
        panVertical: true,
    });
    react_1.useEffect(() => {
        if (viewer && isMobile) {
            viewer.viewport.zoomTo(3);
            // @ts-ignore missing minZoomLevel type
            viewer.viewport.minZoomLevel = 2;
        }
        else if (viewer) {
            viewer.viewport.zoomTo(1);
            // @ts-ignore missing minZoomLevel type
            viewer.viewport.minZoomLevel = 1;
        }
    }, [viewer, isMobile, viewerLoaded]);
    react_1.useEffect(() => {
        if (viewer && selectedMarker && isMobile) {
            viewer.viewport.zoomTo(4);
            viewer.viewport.panTo(new openseadragon_1.Point(selectedMarker.relX, selectedMarker.relY + 0.15));
        }
        else if (viewer && selectedMarker) {
            viewer.viewport.zoomTo(3);
            viewer.viewport.panTo(new openseadragon_1.Point(selectedMarker.relX + 0.1, selectedMarker.relY));
        }
        else if (viewer && !selectedMarker && isMobile) {
            viewer.viewport.zoomTo(3);
        }
        else if (viewer && !selectedMarker && !isMobile) {
            viewer.viewport.zoomTo(2);
        }
    }, [selectedMarker]);
    return (react_1.default.createElement(ViewerWrapper, { ref: openSeadragonRef, cursor: viewerCursor }, children));
};
exports.Viewer = Viewer;
// Note: should show info onAnimationEnd?
